/**
 * Address Service
 *
 * Service for fetching Vietnam administrative divisions from backend
 * Backend proxies calls to production.cas.so/address-kit and caches in Redis
 */

const getApiBaseUrl = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3001/api/v1';
  }
  return `${window.location.origin}/api/v1`;
};

const ADDRESS_API_BASE = `${getApiBaseUrl()}/address`;

interface Province {
  code: string;
  name: string;
  englishName: string;
  administrativeLevel: string;
  decree: string;
}

interface Commune {
  code: string;
  name: string;
  englishName: string;
  administrativeLevel: string;
  provinceCode: string;
  provinceName: string;
  decree: string;
}

class AddressService {
  /**
   * Get all provinces (cached by backend in Redis)
   */
  async getProvinces(): Promise<Province[]> {
    try {
      const response = await fetch(`${ADDRESS_API_BASE}/provinces`);

      if (!response.ok) {
        throw new Error('Failed to fetch provinces');
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching provinces:', error);
      throw error;
    }
  }

  /**
   * Get communes for a specific province (cached by backend in Redis)
   */
  async getCommunes(provinceCode: string): Promise<Commune[]> {
    try {
      const response = await fetch(`${ADDRESS_API_BASE}/provinces/${provinceCode}/communes`);

      if (!response.ok) {
        throw new Error(`Failed to fetch communes for province ${provinceCode}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`Error fetching communes for province ${provinceCode}:`, error);
      throw error;
    }
  }
}

export const addressService = new AddressService();
export type { Province, Commune };
